// Import Tailwind CSS
import '../styles/tailwind.css'

// Import custom SCSS styles
import '../scss/app.scss'

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

// Import Alpine stores and components
import globalLoader from './alpine/stores/globalLoader.js';
import autoFitText from './alpine/components/autoFitText.js';
import listingFilter from './alpine/components/listingFilter.js';
import formReferer from './alpine/components/formReferer.js';
import fixedDropdown from './alpine/components/fixedDropdown.js';

// Register plugins before any data registration
Alpine.plugin(collapse);

// Register stores
Alpine.store('globalLoader', globalLoader);

// Register components
Alpine.data('autoFitText', autoFitText);
Alpine.data('listingFilter', listingFilter);
Alpine.data('formReferer', formReferer);
Alpine.data('fixedDropdown', fixedDropdown);

// Make Alpine available globally and start
window.Alpine = Alpine;
Alpine.start();

window.getCookie = function(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}